import { render, staticRenderFns } from "./PageAccessDenied.vue?vue&type=template&id=b5219706&scoped=true&"
import script from "./PageAccessDenied.vue?vue&type=script&lang=js&"
export * from "./PageAccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessDenied.vue?vue&type=style&index=0&id=b5219706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5219706",
  null
  
)

export default component.exports